module.exports = ["الآن",["منذ %s ثانية","منذ %s ثوانٍ"],["منذ %s دقيقة","منذ %s دقائق"],["منذ %s ساعة","منذ %s ساعات"],["منذ %s يوم","منذ %s أيام"],["منذ %s أسبوع","منذ %s أسابيع"],["منذ %s شهر","منذ %s أشهر"],["منذ %s عام","منذ %s أعوام"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/ar-SA.json
// module id = lUAg
// module chunks = 1